import { render, staticRenderFns } from "./closedTradeModal.vue?vue&type=template&id=ae8b1494&scoped=true&"
import script from "./closedTradeModal.vue?vue&type=script&lang=js&"
export * from "./closedTradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b1494",
  null
  
)

export default component.exports